import React from 'react';
import PropTypes from 'prop-types';

import { Accordion as AccordionOriginal } from '@nextiva/next-ui';

export class Accordion extends React.Component {
  static propTypes = {
    ...AccordionOriginal.propTypes,
    onClick: PropTypes.func.isRequired,
  };

  static defaultProps = AccordionOriginal.defaultProps;

  state = {
    openItems: this.props.openItems || {},
  };

  handleItemToggleRequest = (event, { id }) => {
    const { openItems } = this.state;

    if (!openItems[id]) {
      this.props.onClick();
    }

    this.setState({
      openItems: {
        ...openItems,
        [id]: !openItems[id],
      },
    });
  };

  render() {
    return (
      <AccordionOriginal
        {...this.props}
        openItems={this.state.openItems}
        onItemToggleRequest={this.handleItemToggleRequest}
      />
    );
  }
}
